// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useState} from 'react';
import cn from 'classnames';
import zurl from 'zurl';
import zutil from 'zutil';
import hopt from 'hola_opt';
import {get_icon} from '../ui_utils';

const get_aff_conf = (a_aid?: string)=>{
    a_aid = a_aid||zurl.qs_parse(location.search.substr(1),
        {safe: true}).a_aid;
    const aff_pages = zutil.get(hopt, `www_hola.aff_pages`, {});
    const keys_aff = Object.keys(aff_pages);
    const key_find = keys_aff.find(ap=>aff_pages[ap].aff_id==a_aid);
    return aff_pages[key_find] || {};
};
const Aff_icon = ({aff_conf})=>{
    aff_conf = aff_conf||get_aff_conf();
    const referrer = aff_conf.url || document.referrer;
    let img_src = aff_conf.site_icon;
    if (!img_src)
    {
        const domain = zurl.parse(referrer).hostname;
        img_src = get_icon(domain,
            zutil.get(hopt, 'www_hola.siteicon.enabled'));
    }
    const [img_loaded, set_img_loaded] = useState(false);
    const on_img_load = ()=>{ set_img_loaded(true); };
    return <a href={referrer}
      className={cn('aff_icon', !img_loaded && 'invisible')}>
      <span>As recommended by</span>
      <img src={img_src} onLoad={on_img_load} alt={referrer}
        className="lazyload"/>
    </a>;
};

export {Aff_icon, get_aff_conf};
